import React, { useState } from "react";
import {
  Breadcrumbs,
  Typography,
  Box,
  IconButton,
  Collapse,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChalkboardUser,
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useTheme } from "@mui/material/styles";

const CustomBreadcrumbs = ({ pageName, icon, headerAction }) => {
  const theme = useTheme();
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <Box
      sx={{
        backgroundColor:
          theme.components.MuiBreadcrumbs.styleOverrides.root.backgroundColor,
        color: theme.components.MuiBreadcrumbs.styleOverrides.root.color,
        padding: "20px",
        borderRadius: "10px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Collapsed Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          cursor: "pointer",
        }}
        onClick={toggleExpanded}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography
            variant="h5"
            fontWeight="bold"
            sx={{
              color: theme.palette.mode === "dark" ? "#ffffff" : "#ffffff",
            }}
          >
            {pageName}
          </Typography>
          {headerAction && (
            <Box onClick={(e) => e.stopPropagation()}>{headerAction}</Box>
          )}
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <FontAwesomeIcon
            icon={icon}
            size="2x"
            style={{
              color: "#000",
            }}
          />
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              toggleExpanded();
            }}
            sx={{
              color: "#ffffff",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.1)",
              },
            }}
          >
            <FontAwesomeIcon
              icon={isExpanded ? faChevronUp : faChevronDown}
              style={{ color: "#ffffff" }}
            />
          </IconButton>
        </Box>
      </Box>

      {/* Expandable Breadcrumbs Section */}
      <Collapse in={isExpanded}>
        <Box
          sx={{ mt: 2, pt: 2, borderTop: "1px solid rgba(255, 255, 255, 0.2)" }}
        >
          <Breadcrumbs separator="•" aria-label="breadcrumb">
            <Link
              underline="hover"
              color="inherit"
              to="/CcpSchoolAccountProfile"
              style={{
                color: theme.palette.mode === "dark" ? "#ffffff" : "#ffffff",
              }}
            >
              Account Profile
            </Link>
            <Link
              underline="hover"
              color="inherit"
              to="/CcpSchoolAppsAndTesting"
              style={{
                color: theme.palette.mode === "dark" ? "#ffffff" : "#ffffff",
              }}
            >
              Applications & Testing
            </Link>
            <Link
              underline="hover"
              color="inherit"
              to="/CcpSchoolHelp"
              style={{
                color: theme.palette.mode === "dark" ? "#ffffff" : "#ffffff",
              }}
            >
              Help & FAQ's
            </Link>
            <Link
              underline="hover"
              color="inherit"
              to="/CcpSchoolReports"
              style={{
                color: theme.palette.mode === "dark" ? "#ffffff" : "#ffffff",
              }}
            >
              Reports
            </Link>
            <Link
              underline="hover"
              color="inherit"
              to="/CcpSchoolRestrictedCourses"
              style={{
                color: theme.palette.mode === "dark" ? "#ffffff" : "#ffffff",
              }}
            >
              Restricted Courses
            </Link>
            <Link
              underline="hover"
              color="inherit"
              to="/CcpSchoolCoursePlanning"
              style={{
                color: theme.palette.mode === "dark" ? "#ffffff" : "#ffffff",
              }}
            >
              Course Planning
            </Link>
            <Link
              underline="hover"
              color="inherit"
              to="/CcpStatsAndTrends"
              style={{
                color: theme.palette.mode === "dark" ? "#ffffff" : "#ffffff",
              }}
            >
              Stats & Trends
            </Link>
          </Breadcrumbs>
        </Box>
      </Collapse>
    </Box>
  );
};

export default CustomBreadcrumbs;
